import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Icon from 'components/generic/Icon.component';
import withSalonCurrency from 'components/hoc/withSalonCurrency.hoc';
import DELAY from 'constants/delay.const';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { fromPropsToPath } from 'utils/converters/props/path.util';
import delayed from 'utils/functions/delayed.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import { addService } from 'booking/actions';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import PageTitle from 'booking/components/common/PageTitle';
import ServiceItem from 'booking/components/common/ServiceItem';

import CN from './ServiceCategory.module.scss';

const CTAG = 'ServiceCategory';
const L = logger(CTAG);

// FIXME: replace inline styles with SCSS modules
const SERVICE_LIST_STYLE = { paddingTop: 15 };

const ServiceCategory = (props) => {
  const { addService, client, pickedCategory } = props;
  const { color, services, name } = asObject(pickedCategory);

  const path = fromPropsToPath(props);
  const goBack = useCallback(() => void navFor(CTAG, props).back(), [props]);

  const backgroundColor = useMemo(() => ({ backgroundColor: color }), [color]);

  return (
    <div data-bem="ServiceCategory">
      <div data-bem="ServiceCategory__container-wrapper" className="BookingWindow">
        <section data-bem="ServiceCategory__container" className="sub-list-services">
          <HeaderWrapper>
            <div className={CN.header}>
              <div data-bem="ServiceCategory__go-back" className={CN.icon} role="button" onClick={goBack}>
                <Icon variant="arrowRight" variantInvertDark width="lg" />
              </div>
              <PageTitle pageTitle={name} subTitle="" />
            </div>
          </HeaderWrapper>

          <BWContent additionalClass="space">
            <div data-bem="ServiceCategory__content" className="service-list" style={SERVICE_LIST_STYLE}>
              {pickedCategory && (
                <div>
                  <section data-bem="ServiceCategory__category-list" className="category-list">
                    <div data-bem="ServiceCategory__category-item" className="category-container pd-bottom">
                      {asArray(services).map((service) => {
                        // TODO: check i18n+L10n
                        const handleClick = () => {
                          const { id: serviceId, appointment } = service;
                          const newService = {
                            ...service,
                            appointment: appointment || {},
                            service_id: serviceId,
                            color,
                          };

                          delete newService.id;
                          // FIXME: shared mutable state, it also changes the old service appointment
                          newService.appointment.client = { ...client, notes: '' };

                          addService(newService);

                          // NOTE: this component assumes certain URL changes were done to reach it,
                          // so it assumes by going back and then figuring out the path through the resulting URL
                          // would allow it to go further back to the start of the flow
                          // FIXME: these assumptions are brittle and will tend to break over time

                          L.info('handleClick()', 'location:', fromAnyToString(window.location));
                          goBack(); // FIXME: instead of this, go directly to the start of the flow

                          // FIXME: use more reliable and less coupled way of exiting from AddAnotherService flow
                          const index = path.indexOf('addanotherservice');
                          const isPathAddAnother = L.info('handleClick()', path, 'isPathAddAnother:', index > 0);
                          isPathAddAnother && goBack(); // FIXME: instead of this, go directly to the start of the flow

                          delayed(DELAY.attention, () => {
                            const index = path.indexOf('appointment/edit/');
                            const isPathEdit = L.info('handleClick()', path, 'isPathEdit:', index > 0);
                            // eslint-disable-next-line max-len
                            isPathEdit && !isPathAddAnother && goBack(); // FIXME: instead of this, go directly to the start of the flow
                          });

                          delayed(DELAY.flash, () => {
                            const div = document.querySelector('.bw-content-wrapper.space');
                            div && div.scrollIntoView();
                          });
                        };

                        return (
                          <div data-bem="ServiceCategory__service-item" key={service.id}>
                            <ServiceItem service={service} onClickService={handleClick} backgroundColor={backgroundColor.backgroundColor} />
                          </div>
                        );
                      })}
                    </div>
                  </section>
                </div>
              )}
            </div>
          </BWContent>
        </section>
      </div>
    </div>
  );
};

const ServiceCategoryHoc = connect(
  (state) => ({
    client: state.booking.client,
    pickedCategory: state.booking.pickedCategory,
    salonId: state.currentSalon.id,
  }),
  (dispatch) => bindActionCreators({ addService }, dispatch),
)(withSalonCurrency(ServiceCategory));

export default ServiceCategoryHoc;
